// Panel genelinde içerik gösterimi için ortak yardımcılar.
// Mobil uygulamadan gelen başlık/açıklama alanları HTML içerdiği için
// tablolarda düz metne çevrilip kısaltılması, detayda ise render edilmesi gerekiyor.

const IMAGE_BASE = "https://megasubdomain.stechomeyazilim.info";
const UPLOADS_BASE = "https://berlinesnafapi.stechomeyazilim.com/Uploads";

/** HTML etiketlerini ve entity'lerini temizleyip düz metin döndürür. */
export const stripHtml = value => {
  if (value == null) return "";
  const text = String(value)
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/<\/(p|div|li|tr|h[1-6])>/gi, " ")
    .replace(/<[^>]*>/g, " ");
  const el = typeof document !== "undefined" ? document.createElement("textarea") : null;
  let decoded = text;
  if (el) {
    el.innerHTML = text;
    decoded = el.value;
  }
  return decoded.replace(/ /g, " ").replace(/\s+/g, " ").trim();
};

/**
 * Kullanıcıdan gelen HTML'i panelde göstermeden önce temizler.
 * Onay bekleyen içerikler mobil kullanıcılar tarafından yazılıyor; ham HTML'i
 * doğrudan render etmek panelde XSS'e açık kapı bırakır.
 */
export const sanitizeHtml = value => {
  if (value == null) return "";
  let html = String(value);

  if (typeof document === "undefined") {
    // Sunucu tarafinda (test vb.) calisirsa etiketleri tamamen at
    return html.replace(/<[^>]*>/g, " ");
  }

  const template = document.createElement("div");
  template.innerHTML = html;

  const FORBIDDEN = ["SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED", "LINK", "META", "FORM"];
  template.querySelectorAll("*").forEach(el => {
    if (FORBIDDEN.includes(el.tagName)) {
      el.remove();
      return;
    }
    Array.from(el.attributes).forEach(attr => {
      const name = attr.name.toLowerCase();
      const val = String(attr.value || "").replace(/\s+/g, "").toLowerCase();
      if (name.startsWith("on")) el.removeAttribute(attr.name);
      else if ((name === "href" || name === "src" || name === "xlink:href") &&
        (val.startsWith("javascript:") || val.startsWith("data:text/html"))) {
        el.removeAttribute(attr.name);
      }
    });
  });

  return template.innerHTML;
};

/** Uzun metni tablo hücresine sığacak şekilde kısaltır. */
export const truncate = (value, length = 80) => {
  const text = stripHtml(value);
  return text.length > length ? `${text.slice(0, length)}…` : text;
};

/** Zaten tam URL ise dokunmaz, değilse verilen tabana ekler. */
export const resolveUrl = (fileName, base = IMAGE_BASE) => {
  if (!fileName) return null;
  const name = String(fileName);
  return name.startsWith("http") ? name : `${base}/${name}`;
};

/** İlan görselleri farklı bir sunucuda duruyor (mobil ile aynı mantık). */
export const resolveJobAdImage = fileName => resolveUrl(fileName, UPLOADS_BASE);

export { IMAGE_BASE, UPLOADS_BASE };
